<template>
  <div id="contenedor-agregar-contrato-insumo">
    <v-form v-model="formularioValido" ref="formAgregarContratoInsumo">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nuevo insumo
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-autocomplete
            cols="12"
            v-model="insumo.idInsumo"
            label="Insumo"
            :items="mixGetCatalogoInsumos"
            item-value="id"
            item-text='descripcion'
            :rules="[mixReglas.requerido]"
            required>
          </custom-autocomplete>
          <v-row>
            <!-- <custom-select
              cols="12"
              :md="$vuetify.breakpoint.mobile ? '12' : '6'"
              v-model="insumo.tipo"
              label="Tipo"
              :items="tiposInsumo"
              :rules="[mixReglas.requerido]"
              required>
            </custom-select> -->
            <text-field
              cols="12"
              :md="$vuetify.breakpoint.mobile ? '12' : '6'"
              v-model.number="insumo.cantidad"
              label="Cantidad"
              type="number"
            >
            </text-field>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarContratoInsumo"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixInsumosContrato from './mixInsumosContrato';
import TextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
// import CustomSelect from '@/components/inputs/Select.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';

export default {
  name: 'AgregarContratoInsumo',
  mixins: [mixInsumosContrato],
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  components: {
    TextField,
    CustomButton,
    // CustomSelect,
    CustomAutocomplete,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      tiposInsumo: [
        'SupExt',
        'Contratista',
      ],
      insumo: {
        idContrato: this.idContrato,
        idInsumo: '',
        tipo: '',
        cantidad: 0,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.formAgregarContratoInsumo.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style>

</style>
